if (!customElements.get('te-gift-finder')) {
  customElements.define('te-gift-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.step = 0;
      this.form = this.querySelector('form');
      this.panels = [...this.querySelectorAll('[data-step]')];
      this.results = this.querySelector('.te-gift__results');
      this.next = this.querySelector('.te-gift__next');
      this.back = this.querySelector('.te-gift__back');
      this.find = this.querySelector('.te-gift__find');
      this.form.hidden = false;
      this.form.addEventListener('change', () => this.update());
      this.next.addEventListener('click', () => {
        if (!this.selected()) return;
        this.step++;
        this.update(true);
      });
      this.back.addEventListener('click', () => {
        this.step--;
        this.update(true);
      });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.step !== 2) {
          if (this.selected()) { this.step++; this.update(true); }
          return;
        }
        if (this.panels.some(panel => !panel.querySelector('input:checked'))) return;
        this.showResults();
      });
      this.querySelector('.te-gift__restart').addEventListener('click', () => {
        this.form.reset();
        this.step = 0;
        this.results.hidden = true;
        this.querySelector('.te-gift__intro').hidden = false;
        this.form.hidden = false;
        this.update(true);
      });
      this.update();
    }
    selected() { return this.panels[this.step].querySelector('input:checked'); }
    update(focus = false) {
      this.panels.forEach((panel, index) => { panel.hidden = index !== this.step; });
      this.back.hidden = this.step === 0;
      this.next.hidden = this.step === 2;
      this.find.hidden = this.step !== 2;
      this.next.disabled = !this.selected();
      this.find.disabled = !this.selected();
      const progress = this.querySelector('[data-progress]');
      progress.parentElement.dataset.stepIndex = this.step;
      progress.textContent = progress.dataset.format.replace('[current]', this.step + 1);
      if (focus) this.panels[this.step].querySelector('input').focus();
    }
    showResults() {
      const answers = new FormData(this.form);
      const budget = answers.get('budget') === 'any' ? Infinity : Number(answers.get('budget')) * 100;
      const style = answers.get('style');
      const groups = { traditional: ['nativity', 'decor'], sparkle: ['lights'], playful: ['villages', 'inflatables'] };
      const preferences = { family: ['villages', 'nativity', 'decor'], friend: ['decor', 'lights', 'villages'], home: ['lights', 'villages', 'decor'] }[answers.get('recipient')];
      const products = new Map();
      this.querySelectorAll('template[data-product]').forEach(template => {
        const { product, price, group } = template.dataset;
        if (Number(price) > budget || (groups[style] && !groups[style].includes(group))) return;
        const rank = preferences.indexOf(group);
        const score = rank < 0 ? 10 : rank;
        const current = products.get(product);
        if (!current || score < current.score) products.set(product, { template, score, price: Number(price) });
      });
      const matches = [...products.values()].sort((a, b) => a.score - b.score || a.price - b.price).slice(0, 6);
      const grid = this.querySelector('.te-gift__grid');
      grid.replaceChildren(...matches.map(match => match.template.content.cloneNode(true)));
      this.querySelector('.te-gift__empty').hidden = matches.length !== 0;
      this.querySelector('.te-gift__shipping').hidden = matches.length === 0;
      this.form.hidden = true;
      this.querySelector('.te-gift__intro').hidden = true;
      this.results.hidden = false;
      this.results.querySelector('h3').focus();
    }
  });
}
